<template>
  <div class="billList">
    <!-- 选择日期 -->
    <div :span="17" class="chooseDate">
      <div class="search_content">
        <img src="@assets/img/calendar2.png" />
        <a-range-picker v-model:value="pickerDate" separator="至" valueFormat="YYYY-MM-DD" @change="dateChange" />
        <a-button @click="batchDownloadDetail">
          <a  class="handleBtn">
            下载详情
          </a>
          </a-button>
      </div>
    </div>
    <!--  -->
    <a-table
      :columns="columns"
      bordered
      :data-source="amountList"
      :pagination="false"
      :row-key="(r) => r.id"
      :loading="loading"
      :row-selection="rowSelection"
      style="font-size:12px"
    >
      <template v-slot:operation="{ text, record }">
        <a-button @click="toDetail(record)">
          <a  class="handleBtn">
            账单明细
          </a>
        </a-button>
        <a-button @click="handleDownload(record)">
          <a  class="handleBtn">
          下载
        </a>
        </a-button>

       <!-- <a @click="createBill(record)" class="handleBtn">
          导入账单
        </a>-->
      </template>


      <template v-slot:checkDate="{ text, record }">
        <div>{{ record.checkBegin + " 至 " + record.checkEnd }}</div>
      </template>

    </a-table>
    <a-pagination
      v-show="amountList.length"
      v-model:current="current"
      :total="total"
      :page-size="10"
      @change="pageChange"
      :show-total="(total, range) => `第${range[0]}条 - 第${range[1]}条  共 ${total} 条`"
    />
    <!-- 导入对账单 -->
    <a-modal v-model:visible="createVisible" title="导入账单" :footer="null" class="creatModel">
      <a-spin :spinning="createSpinning">
        <a-form layout="inline">
          <a-row type="flex" justify="space-around" align="middle" class="creatRow">
            <a-col :span="4">
              <CloudDownloadOutlined />
            </a-col>
            <a-col :span="20">
              <p>填写导入数据信息</p>
              <p>请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除</p>
              <p @click="templateDownload">下载模板</p>
            </a-col>
          </a-row>
          <a-row type="flex" justify="space-around" align="middle" class="creatRow">
            <a-col :span="4">
              <CloudUploadOutlined />
            </a-col>
            <a-col :span="20">
              <p>上传填好的信息表</p>
              <p>文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据</p>
              <a-upload :fileList="fileList" :remove="handleRemove" :beforeUpload="beforeUpload">
                <p class="handle">上传文件</p>
              </a-upload>
            </a-col>
          </a-row>
          <a-row type="flex" justify="space-around" align="middle" class="tipRow">
            <a-col :span="3">
              <ExclamationCircleOutlined />
            </a-col>
            <a-col :span="21">
              <p>特别提示</p>
              <p>单号不能重复</p>
            </a-col>
          </a-row>

          <a-form-item>
            <a-button type="primary" @click="createCancel">
              取消
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="handleUpload">上传</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import myApi from "@axios/my";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  ExclamationCircleOutlined,
  UploadOutlined
} from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";

export default {
  name: "offlineBillList",
  components: {
    CloudDownloadOutlined,
    CloudUploadOutlined,
    ExclamationCircleOutlined,
    UploadOutlined
  },
  setup() {
    let router = useRouter();
    const route = useRoute();

    // 日期
    let pickerDate = ref([]);
    const dateChange = (date) => {
      getAmountList();
    };

    let loading = ref(false);

    let amountList = ref([]);

    let current = ref(1);
    let total = ref(0);

    const getAmountList = () => {
      if (loading.value) {
        return;
      }
      let params = {
        size: 10,
        currentPage: current.value
      };
      if (pickerDate.value.length) {
        params.checkBegin = pickerDate.value[0];
        params.checkEnd = pickerDate.value[1];
      }
      loading.value = true;
      myApi
        .getOfflineBillList(params)
        .then((res) => {
          amountList.value = res.data;
          current.value = res.currentPage;
          total.value = res.total;

          loading.value = false;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const pageChange = (page) => {
      current.value = page;
      getAmountList();
    };

    // 详情
    const toDetail = (row) => {
      console.log(row);
      router.push({
        name: "offlineBillListDetail",
        query: {
          id: row.id,
          billNo: row.billNo,
          supplierId: row.supplierId,
          checkTime: row.checkTime,
          checkDate: row.checkDate,
          billOrderType:row.billOrderType
        }
      });
    };

    getAmountList();

    // 导出
    const handleDownload = (item) => {
      let params = {
        billNo: item.billNo,
        billOrderType:item.billOrderType
      };
      console.log("下载模板{}",params)
      const name = getBillOrderType(params.billOrderType)+'单线下票渠道结算单明细';
      let fileName = name + item.billNo;

      exportOut(
        params, // 导出请求参数
        "/business-finance/electronic/distributor/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    // 创建对账单
    let createVisible = ref(false);
    let id = ref("");
    const createBill = (item) => {
      createVisible.value = true;
      id.value = item.id;
    };
    const createCancel = () => {
      createVisible.value = false;
    };

    const getBillOrderType = (val) => {
      if (val === 10){
        return '出票';
      }else if(val === 20){
        return '改签'
      }else if(val === 30){
        return '退票'
      }else if(val === 40){
        return '退款'
      }else if(val === 50){
        return '出退改'
      }
    }


    // 下载模板
    const templateDownload = (item) => {
      let params = {
        billNo: item.billNo,
        billOrderType:item.billOrderType
      };
      console.log("下载模板{}",params)
      const name = getBillOrderType(params.billOrderType)+'单线下票渠道结算单明细';
      let fileName = name + item.billNo;
      exportOut(
        params, // 导出请求参数
        "/business-finance/distributor/bill/download/template", // 接口地址
        fileName // 导出文件名字
      );
    };
    // 文件上传
    let createSpinning = ref(false);
    let fileList = ref([]);
    const handleRemove = (file) => {
      // 移除文件时，要重新给fileList赋值
      let arr = [];
      for (let i = 0; i < fileList.value.length; i++) {
        if (fileList.value[i].uid !== file.uid) {
          arr.push(fileList.value[i]);
        }
      }
      fileList.value = arr;
      console.log(fileList.value);
    };
    // 上传前校验
    const beforeUpload = (file) => {
      console.log(file);
      // const isXlsOrXlsx = file.type === "xls" || file.type === "xlsx";
      // if (!isXlsOrXlsx) {
      //   message.error("只能上传xls 或xlsx （即Excel格式）!");
      // }
      // const isLt10M = file.size / 1024 / 1024 < 10;
      // if (!isLt10M) {
      //   message.error("文件大小不得大于10M!");
      // }
      // return isXlsOrXlsx && isLt10M;
      fileList.value = [...fileList.value, file];
      return false;
    };
    // 上传
    const handleUpload = () => {
      console.log(id.value);
      createSpinning.value = true;
      console.log(fileList.value);
      const formData = new FormData();
      fileList.value.forEach((file) => {
        formData.append("file", file);
        console.log(file);
      });
      formData.append("id", id.value);
      myApi.importBillDetail(formData).then((res) => {
        console.log(res);
        fileList.value = [];
        message.success("上传成功");
        createSpinning.value = false;
        createVisible.value = false;
        getList();
      });
    };


    let batchSelectData = ref([]);

    //根据选择批量下载账单详情
    const batchDownloadDetail = () => {

      if (batchSelectData.value.length <= 0){
        message.warn("请先选择要下载的账单")
        return
      }
      batchSelectData.value.forEach(item=>{

        let params = {
          billNo: item.billNo,
          billOrderType:item.billOrderType
        };
        const name = getBillOrderType(params.billOrderType)+'单线下票渠道结算单明细';
        let fileName = name + item.billNo;
        exportOut(
            params, // 导出请求参数
            "/business-finance/electronic/distributor/bill/download", // 接口地址
            fileName // 导出文件名字
        );
      })
    };
    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        batchSelectData.value = selectedRows
      },
      onSelect: (record, selected, selectedRows) => {
       // console.log(record, selected, selectedRows);
      },
      onSelectAll: (selected, selectedRows, changeRows) => {
       // console.log(selected, selectedRows, changeRows);
      },
    };


    return {
      batchSelectData,
      batchDownloadDetail,
      rowSelection,
      toDetail,
      pageChange,
      total,
      amountList,
      loading,
      pickerDate,
      dateChange,
      current,
      columns: [
          {
              title: "结算单编号",
              dataIndex: "billNo",
              //width: 180,
              align: "center"
              // className: `${"underlineStyle"}`
          },
          {
            title: "渠道商",
            dataIndex: "distributorName",
            //width: 120,
            align: "center"
            // className: `${"underlineStyle"}`
          },
          {
            title: "订单类型",
            dataIndex: "billOrderTypeStr",
            //width: 120,
            align: "center"
            // className: `${"underlineStyle"}`
          },
        {
          title: "订单数",
          dataIndex: "orderCount",
          //width: 60,
          align: "center"
        }, {
          title: "出票数",
          dataIndex: "ticketCount",
          //width: 60,
          align: "center"
        }, {
          title: "销售金额",
          dataIndex: "saleAmount",
          //width: 120,
          align: "center"
        }, {
          title: "结算金额",
          dataIndex: "orderAmount",
          //width: 120,
          align: "center"
        }, {
          title: "退款金额",
          dataIndex: "retrunAmount",
          //width: 120,
          align: "center"
        },
        {
          title: "生成时间",
          dataIndex: "createTime",
          //width: 200,
          align: "center"
          // className: `${"underlineStyle"}`
        },
        {
            title: "对账时段",
            dataIndex: "checkDate",
            //width: 200,
            align: "center",
            slots: { customRender: "checkDate" },
        },
        {
          title: "操作",
          dataIndex: "",
          width: 200,
          align: "center",
          slots: { customRender: "operation" },
          className: `${"operationStyle"}`,
          //fixed: "right"
        }
      ],
      handleDownload,
      createBill,
      createVisible,
      id,
      templateDownload,
      createCancel,
      fileList,
      beforeUpload,
      handleRemove,
      handleUpload,
      createSpinning
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.search_content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.orderCode_span {
  // color:#0D6DBF;
  cursor: pointer;
}
.changeType {
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  // font-weight: 600;
  color: #000000;
}
.first_p {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
}
.topTitle {
  background: #f8f8f8;
  padding: 8px 22px 7px 0;
  margin-bottom: 12px;
  text-align: right;
  .submitBtn {
    background: #ffab00;
    border-color: #ffab00;
    margin-left: 17px;
    width: 101px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    border-radius: 4px;
  }
}
.chooseDate {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
  img {
    width: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .ant-calendar-picker {
    width: 216px;
  }
}
.handleBtn {
  display: block;
  line-height: 1.8;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    color: #40a9ff;
  }
}
.item_content {
  padding: 0 16px 0 20px;
}
.item_content:hover {
  background: #e6f7ff !important;
}
.amount-list {
  margin-top: 13px;
  // padding: 0 16px 0 20px;
  border: 0.5px solid #dbdce0;
  padding: 6px 0;
  // padding-bottom: 250px;
  .item {
    padding: 15px 0 6px 0;
    border-bottom: 1px solid #dbdce0;
    .item-left {
      & div {
        display: inline-block;
      }
      .changeType {
        vertical-align: top;
        font-size: 14px;
        line-height: 22px;
        margin-right: 22px;
      }
      .info {
        color: #000000;
        font-family: PingFangSC-Light, PingFang SC;
        font-size: 14px;
        line-height: 20px;

        & span:nth-of-type(2) {
          font-family: PingFangSC-Light, PingFang SC;
          color: #929395;
        }
      }
    }
    .item-right {
      text-align: right;
      font-size: 16px;
      line-height: 22px;
      color: #929395;
    }
  }
  .item_content:last-of-type {
    .item {
      border: none;
    }
  }
  .ant-pagination {
    text-align: center;
    margin-top: 40px !important;
  }
}
.creatRow {
  border: 1px solid #f5f5f5;
  margin-bottom: 15px;
  .ant-col-4 {
    text-align: center;
    font-size: 30px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
      color: #666;
    }
    &:nth-of-type(3) {
      color: #40a9ff;
      cursor: pointer;
    }
  }
  .handle {
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 10px;
    color: #40a9ff;
    cursor: pointer;
  }
}
.tipRow {
  border: 1px solid #ffe58f;
  margin-bottom: 15px;
  background: #fffbe6;
  color: #888;
  .ant-col-3 {
    text-align: center;
    font-size: 20px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
    }
  }
}
</style>
